import React, { useState,useEffect }  from 'react';
import {Link} from 'react-router-dom'
import axios from 'axios';

import { BASE_URL } from '../Config/Base';

import { Oval } from  'react-loader-spinner'
import _ from 'lodash'



const pageSize =5;

const TecProductMain = () => {
 

   
  useEffect(()=>{  
    document.getElementById("PopAAdd").style.display="none"
    document.getElementById("PopATable").style.display="none"
   
    getTecProducts()


    setpop(true);
    setTimeout(() => {
            
      getroleAction() 
      
       }, 1000);
    setTimeout(() => {
            
      setpop(false);
      getAssignedAction()
    
        
       }, 2000);
   
  }, [])

  const[pop,setpop] = useState(false);

  let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken')); 

  const [sectionProducts, setSectionProducts] = useState([])
  const [EditSectionProducts, setEditSectionProducts] =useState([])

  const [paginatedPosts, setpaginatedPosts] = useState();
  const [currentPage, setcurrentPage] = useState(1);
 ///getTecProducts


 function getTecProducts()
 {



 fetch(`${BASE_URL}/Tec/GettecProducts`, {

   method: 'GET',

   headers: {

     "Content-type": "application/json",

     "Accept": "application/json",

    

     "Access-Control-Allow-Headers": "Access-Control-Request-Headers "

   },

   //body:JSON.stringify(data)

 }).then(response => response.json())

   .then(data => {
     console.log("DatasectionA", data);
     setSectionProducts(data)
     setpaginatedPosts(_(data).slice(0).take(pageSize).value());
       }
   );



     }

     const pageCount = sectionProducts? Math.ceil(sectionProducts.length/pageSize) :0;
// if (pageCount === 1)
// return null;

const pages = _.range(1, pageCount+1)

const pagination =(pageNo)=>{

  // if (pageCount === 1)
// return null;
setcurrentPage(pageNo);
const startIndex = (pageNo - 1) * pageSize;
const paginatedPost = _(sectionProducts).slice(startIndex).take(pageSize).value();
setpaginatedPosts(paginatedPost)
}
const onNext = () => {


  pagination(currentPage + 1);
};

const onPrevious = () => {
  pagination(currentPage - 1);
};

       ///submitsectionProducts



  const [fileProducts, setFileProducts] = useState();
  const [fileProductsImg, setFileProductsImg] = useState();
  // console.log(file)
  
  const handleFileChangeProducts = (e) => {
   
      setFileProducts(e.target.files[0]);
      setFileProductsImg(URL.createObjectURL(e.target.files[0]));
  };
 
   // console.log(file)
   
  
 
   function submitsectionProducts(){

    var UserId= localStorage.getItem('UserId')

     var textProducts = document.getElementById("text").value;

     var linkProducts = document.getElementById("link").value;
     var bgProducts = document.getElementById("background").value;


     if(!textProducts){

       document.getElementById("AddErrA").innerHTML="Product Required"

     }
     else if(textProducts){

       document.getElementById("AddErrA").innerHTML=" "

     }
     
     if(!fileProducts){

      document.getElementById("AddErrB").innerHTML="image Required"

    }
    else if(fileProducts){

      document.getElementById("AddErrB").innerHTML=" "

    }

    if(!linkProducts){

      document.getElementById("AddErrC").innerHTML="Link Required"

    }
    else if(linkProducts){

      document.getElementById("AddErrC").innerHTML=" "

    }
    if(!bgProducts){

      document.getElementById("AddErrD").innerHTML="Background Color Required"

    }
    else if(bgProducts){

      document.getElementById("AddErrD").innerHTML=" "

    }

     if(textProducts  && linkProducts && bgProducts){



    const body =
     {
       
       Text:textProducts, 
       Image:fileProducts,
       Color:bgProducts,
       Link:linkProducts,
       ActiveStatus:0,
       DeleteStatus:0,
       CreatedBy:UserId
       

        
     
     }
     console.log('body',body);

   
     axios({
            method:"POST",
            url :`${BASE_URL}/Tec/AddtecProducts`,
            data:body, 
            headers: {
                 "Content-Type": "multipart/form-data",
                 'Authorization':bearer 
             }     
         }) 
 
        .then((response) =>{
        console.log(response.data);
   
   
        if(response.data.status === "Success"){
          
          setSuccessToast(true)
           
          
             setTimeout(() => {
              setSuccessToast(false)
              getTecProducts()

              closeProductsAddForm()
             }, 2000);
           }

   
     })
     .catch(error => {
       console.log(error);
       alert("failed !")
     

     })
       
   }

   }


 ////Get Particular Data PostMethodProducts

 function editSectionProducts(Id){

  SelectParticular(Id)
  document.getElementById("ProductsEditPop").style.display = "block";
 }

  function SelectParticular(Id){
 

const body =
 {
   
  id:Id
 }
 console.log('body',body);


 axios({
        method:"POST",
        url :`${BASE_URL}/Tec/EdittecProducts`,
        data:body, 
        headers: {
             "Content-type": "application/json",
             'Authorization':bearer 
         }     
     }) 
     

     .then((response) =>{
       console.log(JSON.stringify(response.data));
  
   
       setEditSectionProducts(response.data)

      
  
    })
    .catch(error => {
      console.log(error);
      
    })

 }
//function closeform

function closeForm(){

  document.getElementById("modaldeleteForm").style.display ="None"

}

 function updateSectionProducts(Id){
  var UserId= localStorage.getItem('UserId')

  var UserId= localStorage.getItem('UserId')
  var TextProducts = document.getElementById("textA").value;
  var ImagefileFirst = document.getElementById("tecimage").src;

  var linkProduct = document.getElementById("linkA").value;
  var bgProduct = document.getElementById("backgroundA").value;

  if(!TextProducts){

    document.getElementById("ErrA").innerHTML="Product Required"

  }
  else if(TextProducts){

    document.getElementById("ErrA").innerHTML=" "

  }
  
  if(!linkProduct){

    document.getElementById("ErrB").innerHTML="Link Required"

  }
  else if(linkProduct){

    document.getElementById("ErrB").innerHTML=" "

  }
  if(!bgProduct){

    document.getElementById("ErrC").innerHTML="Background Color Required"

  }
  else if(bgProduct){

    document.getElementById("ErrC").innerHTML=" "

  }
 
 
  if(TextProducts&& linkProduct && bgProduct){


  



const body =
{
  Id:Id,
  Text:TextProducts, 
  Image:fileProducts,
  Color:bgProduct,
  Link:linkProduct,
  OldImage:ImagefileFirst,
  EditedBy:UserId

   

}
console.log('body',body);


axios({
       method:"POST",
       url :`${BASE_URL}/Tec/UpdatetecProducts`,
       data:body, 
       headers: {
            "Content-Type": "multipart/form-data",
            'Authorization':bearer 
        }     
    }) 

   .then((response) =>{
   console.log(response.data);


   if(response.data.status === "Success"){
   
    setUpdateToast(true)
    closeProductsEditForm()
        setTimeout(() => {
        
         getTecProducts()
         setUpdateToast(false)
         setcurrentPage(1)
        }, 2000);
      }

})
.catch(error => {
  console.log(error);
 alert("failed !")
 
})
  

}

}

 ///DeleteSectionA



 function ConfirmDelete(Id){

  SelectParticular(Id)
  setTimeout(() => {
    document.getElementById("modaldeleteForm").style.display = "block";
  },1000);

}

 function DeleteSectionProducts(Id){

 
 

 const body =
  {
    Id:Id,
 
   

     
  
  }
  console.log('body',body);


  axios({
         method:"POST",
         url :`${BASE_URL}/Tec/DeletetecProducts`,
         data:body, 
         headers: {
            "Content-type": "application/json",
              'Authorization':bearer 
          }     
      }) 

     .then((response) =>{
     console.log(response.data);


     
     
     closeForm()
     setDeleteErrToast(true)
        
          setTimeout(() => {
          
           getTecProducts()
           setcurrentPage(1)
           setDeleteErrToast(false)
          }, 2000);
         
          
        

  })
  .catch(error => {
    console.log(error);
    alert("failed !")
    
  })
    
 



}

//closeAddFormProducts

function closeProductsAddForm(){


  setFileProducts();
 
  setFileProductsImg();
  document.getElementById("AddErrA").innerHTML=" "

  document.getElementById("AddErrB").innerHTML=" "
  document.getElementById("tecform").reset();
         
  document.getElementById("ProductsAddPop").style.display = "none";
 
 
}

 //closeEditForm

 function closeProductsEditForm(){

  setFileProducts();
 
  setFileProductsImg();
  document.getElementById("ErrA").innerHTML=" "
 
  document.getElementById("teceditform").reset();

  
  document.getElementById("ProductsEditPop").style.display = "none";
 }

  //OpenAddForm

  function openProductsForm(){

    document.getElementById("ProductsAddPop").style.display = "block";

  }
  
  function getroleAction(){
  
  
  
    let LoginRole =  localStorage.getItem("Role");
   
    console.log('checkrole',LoginRole);
    const body =
    {
      
     role:LoginRole
    }
    console.log('body',body);
   
   
    axios({
           method:"POST",
           url :`${BASE_URL}/Tec/GetTecRoleAction`,
           data:body, 
           headers: {
                "Content-type": "application/json",
                "Authorization": bearer,
            }     
        }) 
        
   
        .then((response) =>{
          console.log(response.data);
     
       
       
                
          localStorage.setItem("LoginAction",JSON.stringify(response.data))
          localStorage.getItem("LoginAction");
       })
       .catch(error => {
         console.log(error);
   })
   }


  const[editicon,setediticon] = useState(false);
  const[delicon,setdelicon] = useState(false);
  const[denied,setdenied] = useState(false);  
   function getAssignedAction(){
  
  
  
    ////Admin
    let LoginRoleId= localStorage.getItem("RoleId");

    let CheckSAdmin = LoginRoleId.includes("00")
    let CheckAdmin =LoginRoleId.includes("01")
  
  
    /////////////Teammate
      let LoginAction =  localStorage.getItem("LoginAction");
      let TecRoleAction =  JSON.parse(LoginAction);
      let roleAction = TecRoleAction.map((e)=>e.roleAction);
      console.log(roleAction);
      
      let roles = roleAction.toString();
      let roleResult = roles.includes('Add')
      console.log(roleResult)
      
      let roleResultA = roles.includes('View')
      console.log(roleResultA)
      
      let roleResultB = roles.includes('Edit')
      console.log(roleResultB)
      
      let roleResultC = roles.includes('Delete')
      console.log(roleResultC)
  
  
     
  
      if(roleResult==true && CheckSAdmin==false && CheckAdmin==false){
  
        document.getElementById('PopAAdd').style.display ="block";
      }
      else if(CheckSAdmin==true || CheckAdmin==true){
        document.getElementById('PopAAdd').style.display ="block";
      }
      else{
        document.getElementById('PopAAdd').style.display ="none";
  
      }
      if(roleResultA==true  && CheckSAdmin==false && CheckAdmin==false){
  
        document.getElementById('PopATable').style.display ="block";
      }
      else if(CheckSAdmin==true || CheckAdmin==true){
        document.getElementById('PopATable').style.display ="block";
      }
      else{
        document.getElementById('PopATable').style.display ="none";
  
      }
      if(roleResultB==true  && CheckSAdmin==false && CheckAdmin==false){
  
        setediticon(true)
      }
      else if(CheckSAdmin==true || CheckAdmin==true){
        setediticon(true)
      }
      else{
        setediticon(false)
  
      }
      if(roleResultC==true  && CheckSAdmin==false && CheckAdmin==false){
  
        setdelicon(true)
      }
      else if(CheckSAdmin==true || CheckAdmin==true){
        setdelicon(true)
      }
      else{
        setdelicon(false)
  
      }
      if(roleResultB==false  && roleResultC==false && CheckSAdmin==false && CheckAdmin==false){

        setdenied(true)
      }
      else{
  
        setdenied(false)
      }
      if( roleResultA==false && CheckSAdmin==false && CheckAdmin==false){
        document.getElementById("TecActionDenied").innerHTML="View Table is not Assigned"
         }

    }
      
    
    const[SuccessToast,setSuccessToast] = useState(false);  
    const[UpdateToast,setUpdateToast] = useState(false);  
    const[DeleteToast,setDeleteErrToast] = useState(false);
    
  return (
    <div className='tec-addmain'>
      
   
  {/* <div className="tec-addgrid-layout">
<div className="tec-addmain-top">
  <div className='tec-addmain-back'>
  <Link to='/Tecsection'><i class="fa fa-chevron-left" aria-hidden="true"></i></Link>
  </div> 
  <span>Products</span>
  
  </div>
  </div> */}

<div className="tec-addgrid-layout">
    <div className="tec-addmain-top">
 
 <p><span id="tectopspan"><span id="TecTitleMain">OUR PRODUCT</span> </span>
 <div className='tec-addmain-back'>
<Link to="/TecSProduct"><i class="fa fa-angle-double-left" aria-hidden="true" id="tecbackicon"></i></Link>
</div></p> 

 {/* <hr></hr> */}
 </div>
    </div>   

      {/* Toast */}
      {SuccessToast? <div className='tec-toastpop-fade'>
      <div className="modal-dialog" role="document">
      <div id='tecToastcontainer' style={{left:"20%"}}>
    <div id="Tec-success-box">
    <div className="Tec-Toastdot"></div>
    <div className="Tec-Toastdot Tec-Toasttwo"></div>
    <div className="Tec-Toastface">
      <div className="Tec-Toasteye"></div>
      <div className="Tec-Toasteye Tec-Toastright"></div>
      <div className="Tec-Toastmouth Tec-Toasthappy"></div>
    </div>
    <div className="Tec-Toastshadow scale"></div>
    <div className="Tec-Toastmessage"><h1 class="Tec-Toastalert">Success!</h1><p>Added Successfully</p></div>
   
  </div></div></div></div>:null}
   {/* Toast */}
  {DeleteToast? <div className='tec-toastpop-fade'>
      <div className="modal-dialog" role="document">
      <div id='tecToastcontainer' style={{left:"20%"}}>
    <div id="Tec-success-box">
    <div className="Tec-Toastdot"></div>
    <div className="Tec-Toastdot Tec-Toasttwo"></div>
    <div className="Tec-Toastface">
      <div className="Tec-Toasteye"></div>
      <div className="Tec-Toasteye Tec-Toastright"></div>
      <div className="Tec-Toastmouth Tec-Toasthappy"></div>
    </div>
    <div className="Tec-Toastshadow scale"></div>
    <div className="Tec-Toastmessage"><h1 class="Tec-Toastalert">Success!</h1><p>Deleted Successfully</p></div>
   
  </div></div></div></div>:null} 


   {/* Toast */}
   {UpdateToast? <div className='tec-toastpop-fade'>
      <div className="modal-dialog" role="document">
      <div id='tecToastcontainer' style={{left:"20%"}}>
    <div id="Tec-success-box">
    <div className="Tec-Toastdot"></div>
    <div className="Tec-Toastdot Tec-Toasttwo"></div>
    <div className="Tec-Toastface">
      <div className="Tec-Toasteye"></div>
      <div className="Tec-Toasteye Tec-Toastright"></div>
      <div className="Tec-Toastmouth Tec-Toasthappy"></div>
    </div>
    <div className="Tec-Toastshadow scale"></div>
    <div className="Tec-Toastmessage"><h1 class="Tec-Toastalert">Success!</h1><p>Updated Successfully!</p></div>
   
  </div></div></div></div>:null}
  <div className='tec-addmain-add' id="PopAAdd">
      <button className='add-user' onClick={openProductsForm}>  Add Products</button>
 </div>


  <div>
    
    

         {/* EditProducts */}
 <div className='tech-pop-fade' id="ProductsEditPop">
{EditSectionProducts.map((e)=>{
   return<div className="modal-dialog" role="document">
    <div className="modal-content" style={{marginTop:"30px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">EDIT SECTION</h4>
        <button type="button" className="close" onClick={closeProductsEditForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form  id="teceditform" onSubmit={()=>updateSectionProducts(e.id)}>
      <div className="modal-body mx-3">

      <div className="text-center md-form mb-5" style={{marginTop:"-25px"}}>
          {/* <label id="sectionlable">Product Image</label>   */}
           
         <input type="file" onChange={handleFileChangeProducts} style={{opacity:"0",position:"relative",top:"50px",left:"200px",zIndex:"1"}}/>
         {!fileProductsImg?<img id="tecimage" src={e.image}  /> :<img id="tecimage" src={fileProductsImg}  />}
         <span id="editimg-Tec"><i class="fa fa-pencil" aria-hidden="true" ></i></span>
        </div>
        <div className="md-form mb-5">
        <label id="sectionlable">Product</label> 
          <input type="text" id="textA"  defaultValue={e.text}/>
          <span id="ErrA" className='error'></span>
        </div> 
       

        <div className="md-form mb-5">
        <label id="sectionlable">Link</label> 
          <input type="text" id="linkA"  defaultValue={e.link}/>
          <span id="ErrB" className='error'></span>
        </div> 
        <div className="md-form mb-5">
        <label id="sectionlable">Background Color</label> 
          <input type="text" id="backgroundA"  defaultValue={e.color}/>
          <span id="ErrC" className='error'></span>
        </div> 
       
      </div>
      <div className="modal-footer d-flex justify-content-center">
        <button className='tec-adduser-button' type="submit">Update</button>
      </div>
      </form>
    </div>
  </div>})}

</div>

{/* AddProducts */}
<div className='tec-pop-fade' id="ProductsAddPop">

  <div className="modal-dialog" role="document">
    <div className="modal-content" style={{marginTop:"50px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">ADD SECTION</h4>
        <button type="button" className="close" onClick={closeProductsAddForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form  id="tecform" onSubmit={submitsectionProducts} >
      <div className="modal-body mx-3">
        <div className="md-form mb-5">
           
        <label id="sectionlable">Product</label> 
          <input type="text" id="text"/>
          <span id="AddErrA" className='error'></span>
        </div> 

        <div className="md-form mb-5">
          <label id="sectionlable">Image</label>  
 
         <input type="file" onChange={handleFileChangeProducts}/>
         
         <span id="AddErrB" className='error'></span>
        </div>

        <div className="md-form mb-5">
           
           <label id="sectionlable">Link</label> 
             <input type="text" id="link"/>
             <span id="AddErrC" className='error'></span>
           </div> 
           <div className="md-form mb-5">
           
           <label id="sectionlable">Background Color</label> 
             <input type="text" id="background"/>
             <span id="AddErrD" className='error'></span>
           </div> 
      
      </div>
      <div className="modal-footer d-flex justify-content-center">
        <button className='tec-adduser-button' type="submit">Add</button>
      </div>
      </form>
    </div>
  </div>

</div> 








<div className='tec-sectionMain' id="PopATable">
{
   sectionProducts.length==0 ? (<div id="TecApiFail">" No Data Found "</div>):(
<div>
<div className='tectable'>

  <div class="tec-table_responsive">

<table>
  <thead>
    <tr>
      <th>Product</th>
     <th>Image</th>
     <th>Color</th>
     <th>Link</th>
      <th>Action</th>
    </tr>
  </thead>
  <tbody>
    {paginatedPosts.map((e)=>{
    
  
    return<tr>
    <td>{e.text}</td>
    <td><img src={e.image} alt="imgA" id="sectionImage"></img></td>
    <td><div style={{inlineSize:"150px",overflowWrap:"break-word",wordWrap:"break-word"}}>{e.color}</div></td>
    <td><div style={{inlineSize:"150px",overflowWrap:"break-word",wordWrap:"break-word"}}>{e.link}</div></td>
    <td style={{whiteSpace:"nowrap"}}>
    {editicon?<span><i class="fa fa-pencil" aria-hidden="true" onClick={()=>editSectionProducts(e.id)} id="tecEditicon"></i></span>:null} &nbsp;&nbsp;
       {delicon?<span><i class="fa fa-trash" aria-hidden="true" onClick={()=>ConfirmDelete(e.id)} id="tecDelicon"></i></span>:null}
       {denied?<span className='error'>Denied</span>:null}
    </td>
    </tr>
 } )}
  </tbody>
</table>



</div>
</div>

<br></br>
{pageCount==1?null: <nav  id="tecpagenav">
    <ul className='pagination'>
      {/* {
        pages.map((page)=>(
          <li className={
            page === currentPage ? "page-item active" : "page-item"
          }>
            
            
            
            <p className='tecpage-link'onClick={()=>pagination(page)}>
            {page}
            </p>
            </li>
        ))
      } */}
           {currentPage >1?<li className="page-item">
              <a class="tecpage-link" onClick={onPrevious} aria-label="Next">
                <span aria-hidden="true">&laquo;</span>
                <span class="sr-only">Previous</span>
              </a>
            </li>:null}
            &nbsp; &nbsp;
            <span style={{marginTop:"6px"}}>
         Page {currentPage} Of {pageCount} 
         
            </span>   &nbsp; &nbsp;
        {currentPage<pageCount?<li className="page-item">
              <a class="tecpage-link" onClick={onNext} aria-label="Next">
                <span aria-hidden="true">&raquo;</span>
                <span class="sr-only">Next</span>
              </a>
            </li>:null}

    </ul>
  </nav>}
</div>

  )}

 
    </div>
    </div>

    {pop? <div id="Loader">
<Oval
  height={40}
  width={50}

  color="black"
  wrapperStyle={{}}
  wrapperClass=""
  visible={true}
  ariaLabel='oval-loading'
  secondaryColor="gray"
  strokeWidth={2}
  strokeWidthSecondary={2}

/>
     </div>
 :null}



 {/* DeletePopup */}

 {EditSectionProducts.map((e)=>{ 
   return<div className="tec-pop-fade" id="modaldeleteForm" tabindex="-1" role="dialog">
     <div className="modal-dialog" role="document">
      <div className="modal-content" style={{marginTop:"240px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">! Warning</h4>
        <button type="button" className="close" onClick={closeForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

    <form id='form'>

     <div className="modal-body mx-3">

        <div className="md-form mb-4">
            <div className='text-center'>
          <h5 style={{marginTop:"25px"}}>Are you sure want to Delete <span>{e.userName}</span> ?</h5>
          </div>
        </div>

      </div>

       <div className="modal-footer d-flex justify-content-center">
       <button className="tec-adduser-button" onClick={()=>DeleteSectionProducts(e.id)} type='submit'>Delete</button>
        <button className="tec-adduser-button" onClick={closeForm} type='submit'>Cancel</button>
       </div>

       </form>
      
     </div>
    </div>
</div>})}
<div id="TecDenied">
   <span id="TecActionDenied"></span>

   </div>
    </div>
  )
}

export default TecProductMain
